<template lang="html">
  <div class="notificationBox" :class="{'ok': type === 'ok', 'warning': type === 'warning'}">
    <div class="content content-icon">
      <i :class="{'el-icon-success': type === 'ok', 'el-icon-warning': type === 'warning'}"></i>
    </div>
    <div class="content content-text">
      <label>{{text}}</label>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'notificationBox',
    props: {
      type: {          // 'ok', 'warning'
        type: String,
        required: true,
        validator: function (value) {
          return value === 'ok' || value === 'warning'
        }
      },
      text: String      // 表示する内容
    }
  }
</script>

<style lang="css" scoped>
  .warning {
    background-color: #e05050;
    color: white;
  }
  .ok {
    background-color: #58cc1a;
    color: white;
  }
  .content {
    display: inline-block;
    vertical-align: top;
  }
  .content-icon {
    width: 5%;
    margin: 5px 0 0 0;
    text-align: center;
  }
  .content-text {
    width: 94%;
    max-width: -webkit-calc(100% - 30px);
    max-width: calc(100% - 30px);
  }
</style>



// WEBPACK FOOTER //
// NotificationBox.vue?120cce03